<template>
    <div class="travelDetail">
        <home-nav></home-nav>
        <div class="bg_maincolor">
            <div class="contract_bd">
                <div id="header">
                    <div class="crumbs">
                        <div style="display: inline-block;margin-top: 10px;">
                            <a @click="toDingzhi()" style="cursor: pointer;" title="定制旅行" id="j_goIndex">定制旅行</a>
                            >
                            <a href="###" id="crumb" style="color: gray; text-decoration: none; cursor: default;">
                                {{ title }}
                            </a>
                        </div>
                    </div>

                    <div class="contract_tab_div">
                        <div class="contract_tab basefix">
                            <div class="dz_contract_box">
                                <!--<span class="j_dataChangeLastTime dz_contract_time">
                                    | 该案例由
                                    <i class="providerName">
                                        xxx
                                    </i>
                                    为您提供
                                </span>-->
                            </div>
                        </div>
                    </div>

                    <div class="lunbo">
                        <div class="dz_contract_left">
                            <el-carousel
                                    height="387px"
                                    :autoplay="false"
                                    arrow="hover"
                            >
                                <el-carousel-item v-for="(item,index) in carouselList" :key="index">
                                    <img :src="item" alt="">
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div class="dz_contract_right">
                            <div class="dz_contract_top">
                                <div class="bourn_city">
                                    <i class="icon_adress js_destinations">

                                    </i>
                                    目的地：{{ destination }}
                                </div>

                                <h2 class="j_schemeTitle header_font_family">
                                    {{ title }}
                                </h2>

                                <div class="priceBox">
                                    <div class="priceBoxLeft">
                                        <div class="priceBoxLeftFh">¥</div>
                                        <div class="priceBoxLeftNum">{{ per_price }}</div>
                                        <div class="priceBoxLeftText">/起</div>
                                    </div>

                                    <div class="priceBoxRight">
                                        <div class="priceBoxRightOne">
                                            <div class="priceBoxRightOneTop">
                                                在线咨询
                                            </div>
                                            <div class="priceBoxRightOneBottom">
                                                周一至周日 08:30-22:30
                                            </div>
                                        </div>
                                        <div class="priceBoxRightTwo" @click="showMessage()">
                                            定制行程
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="dz_contract_up">
                                <div class="pm_face_recommend">
                                    <div class="pm_recommend">
                                        <div class="leftFh">“</div>
                                        <div class="pm_recommend_content">本案例中的行程为定制师推荐，定制行程后可以根据需要更换景点酒店，增减天数或调整玩法
                                        </div>
                                        <div class="rightFh">”</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div id="tourLineAndQuotePrice">
                    <div class="detail_tab basefix">
                        <ul class="j_detailTab detail_tab_col">
                            <li>
                                <a href="#1" name="cpts" class="current">
                                    旅行特色
                                </a>
                            </li>
                            <li>
                                <a href="#2" name="cpts">
                                    {{ travel_days }}日行程
                                </a>
                            </li>
                            <li>
                                <a href="#3" name="cpts">
                                    参考报价
                                </a>
                            </li>
                            <li>
                                <a href="#4" name="cpts">
                                    预订须知
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="under_tab_detail">
                        <div id="1">
                            <div class="j_jouneyFeature detail_content first_detail_content">
                                <h3 class="resource_title">
                                    旅行特色
                                    <i class="icon_b icon_b_01">

                                    </i>
                                </h3>
                                <div class="product_feature">
                                    <div>
                                        <div class="media-wrap image-wrap">
                                            <!--<p>1</p>
                                            <img src="https://dimg04.c-ctrip.com/images/03C4x120004htwele4EE6.jpg"
                                                 alt="">-->

                                            <div class="xingchengtese">
                                                <div class="xingchengteseLi" v-for="(item,index) in characteristic" :key="index">
                                                    <i class="schemeFeatureTag">
                                                        {{ item.ts_type }}
                                                    </i>
                                                    <img class="schemeImg" :src="item.ts_pic" alt="">
                                                    <div class="schemeFeatureContent">
                                                        <h3>
                                                            {{ item.ts_title }}
                                                        </h3>
                                                        <p>
                                                            {{ item.ts_content }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="2" class="j_jouneyDaysDetail detail_content" style="border: none;">
                            <h3 class="j_daysNumTitle resource_title">
                                {{ travel_days }}日行程
                            </h3>
                            <div class="route_detail">
                                <div class="detail_nav">
                                    <h2>
                                        详细行程
                                    </h2>
                                    <div class="multiple_route">
                                        <div class="multiple_day_nav">

                                        </div>
                                        <div class="multiple_route_mod" v-for="(item,index) in days" :key="index">
                                            <h3 class="multiple_route_tit" style="font-weight: 400;">
                                                <i class="c_day">
                                                    D{{ index+1 }}
                                                </i>
                                                <div class="trip_city">
                                                    <div class="city_name">
                                                        <span>
                                                            {{ item.day_from }} -> {{ item.day_go }}
                                                        </span>
                                                    </div>
                                                    <p class="tips">
                                                        <!--成都-康定-折多山-新都桥-墨石公园-->
                                                        {{ item.day_title }}
                                                    </p>
                                                </div>
                                            </h3>

                                            <div class="multiple_route_con">
                                                <div v-for="(itemIn, idx) in item.xc_list" :key="idx">
                                                    <div class="tourline_v4 multiple_item wan_type undefined">
                                                        <div class="multiple_item_inner">
                                                            <div class="hline">

                                                            </div>
                                                            <h4>
                                                                <i class="customTravel"></i>
                                                                <!--用车：-->
                                                                <span class="item_title">
                                                                    {{ itemIn.day_type }}
                                                                </span>
                                                            </h4>

                                                            <div class="multiple_item_con">
                                                                <div>
                                                                    <div class="item_detail">
                                                                        <div class="item_pic">
                                                                            <img :src="itemIn.day_pic" alt="">
                                                                        </div>
                                                                        <div class="desc">
                                                                            <p class="j_description">
                                                                                {{ itemIn.day_a }} <br>
                                                                                {{ itemIn.day_b }} <br>
                                                                                {{ itemIn.day_c }} <br>
                                                                                {{ itemIn.day_d }} <br>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--<div>
                                                    <div class="tourline_v4 multiple_item wan_type undefined">
                                                        <div class="multiple_item_inner">
                                                            <div class="hline">

                                                            </div>
                                                            <h4>
                                                                <i class="customTravel"></i>
                                                                活动：
                                                                <span class="item_title">
                                                                    全球户外
                                                                </span>
                                                            </h4>

                                                            <div class="multiple_item_con">
                                                                <div>
                                                                    <div class="item_detail">
                                                                        <div class="item_pic">
                                                                            <img src="https://dimg04.c-ctrip.com/images/03C6n120004h076sd95A2_C_300_300.jpg"
                                                                                 alt="">
                                                                        </div>
                                                                        <div class="desc">
                                                                            <p class="j_description">
                                                                                早上07:00成都统一集合出发（3环内专车上门接），经成雅高速进入甘孜藏族自治州境内，翻越康巴第一关折多山，后前往中国的百慕大—八美墨石公园景区游玩，步入墨石公园，传说当年格萨尔王王妃珠姆在此游玩之时，不小心掉下一条丝巾，
                                                                                落在这片格萨尔王战斗过的土地上，变成了卡玛河，滋润着这片石林及当地的人们。石林含钙盐，受空气湿度的影响，
                                                                                干燥季节呈浅灰色、浅蓝色，湿润季节呈苍黑色，又称之为变色石林。午餐后前往塔公草原，藏语意为“菩萨喜欢的地方”，塔公草原因塔公寺而得名。塔公寺是藏传佛教萨迦派寺庙之一，有“小大昭寺”之称，是康巴地区藏民朝拜的圣地之据传说公元641年文成公主进藏与松赞干布完婚时途经木雅人居住的这片草地
                                                                                。前往玛尼河谷后经香薰谷（犹如‘普罗旺斯’一样的薰衣草花海，新增的秘境美景，真是犹如梦境）。返回“光与影的世界”摄影天堂—新都桥镇入住。
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div class="tourline_v4 multiple_item wan_type undefined">
                                                        <div class="multiple_item_inner">
                                                            <div class="hline">

                                                            </div>
                                                            <h4>
                                                                <i class="customTravel"></i>
                                                                活动：
                                                                <span class="item_title">
                                                                    全球户外
                                                                </span>
                                                            </h4>

                                                            <div class="multiple_item_con">
                                                                <div>
                                                                    <div class="item_detail">
                                                                        <div class="item_pic">
                                                                            <img src="https://dimg04.c-ctrip.com/images/03C6n120004h076sd95A2_C_300_300.jpg"
                                                                                 alt="">
                                                                        </div>
                                                                        <div class="desc">
                                                                            <p class="j_description">
                                                                                早上07:00成都统一集合出发（3环内专车上门接），经成雅高速进入甘孜藏族自治州境内，翻越康巴第一关折多山，后前往中国的百慕大—八美墨石公园景区游玩，步入墨石公园，传说当年格萨尔王王妃珠姆在此游玩之时，不小心掉下一条丝巾，
                                                                                落在这片格萨尔王战斗过的土地上，变成了卡玛河，滋润着这片石林及当地的人们。石林含钙盐，受空气湿度的影响，
                                                                                干燥季节呈浅灰色、浅蓝色，湿润季节呈苍黑色，又称之为变色石林。午餐后前往塔公草原，藏语意为“菩萨喜欢的地方”，塔公草原因塔公寺而得名。塔公寺是藏传佛教萨迦派寺庙之一，有“小大昭寺”之称，是康巴地区藏民朝拜的圣地之据传说公元641年文成公主进藏与松赞干布完婚时途经木雅人居住的这片草地
                                                                                。前往玛尼河谷后经香薰谷（犹如‘普罗旺斯’一样的薰衣草花海，新增的秘境美景，真是犹如梦境）。返回“光与影的世界”摄影天堂—新都桥镇入住。
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>-->
                                            </div>
                                        </div>

                                        <!--<div class="multiple_route_mod">
                                            <h3 class="multiple_route_tit" style="font-weight: 400;">
                                                <i class="c_day">
                                                    D1
                                                </i>
                                                <div class="trip_city">
                                                    <div class="city_name">
                                                        <span>
                                                            康定 -> 甘孜
                                                        </span>
                                                    </div>
                                                    <p class="tips">
                                                        成都-康定-折多山-新都桥-墨石公园
                                                    </p>
                                                </div>
                                            </h3>

                                            <div class="multiple_route_con">
                                                <div>
                                                    <div class="tourline_v4 multiple_item wan_type undefined">
                                                        <div class="multiple_item_inner">
                                                            <div class="hline">

                                                            </div>
                                                            <h4>
                                                                <i class="customTravel"></i>
                                                                活动：
                                                                <span class="item_title">
                                                                    全球户外
                                                                </span>
                                                            </h4>

                                                            <div class="multiple_item_con">
                                                                <div>
                                                                    <div class="item_detail">
                                                                        <div class="item_pic">
                                                                            <img src="https://dimg04.c-ctrip.com/images/03C6n120004h076sd95A2_C_300_300.jpg"
                                                                                 alt="">
                                                                        </div>
                                                                        <div class="desc">
                                                                            <p class="j_description">
                                                                                早上07:00成都统一集合出发（3环内专车上门接），经成雅高速进入甘孜藏族自治州境内，翻越康巴第一关折多山，后前往中国的百慕大—八美墨石公园景区游玩，步入墨石公园，传说当年格萨尔王王妃珠姆在此游玩之时，不小心掉下一条丝巾，
                                                                                落在这片格萨尔王战斗过的土地上，变成了卡玛河，滋润着这片石林及当地的人们。石林含钙盐，受空气湿度的影响，
                                                                                干燥季节呈浅灰色、浅蓝色，湿润季节呈苍黑色，又称之为变色石林。午餐后前往塔公草原，藏语意为“菩萨喜欢的地方”，塔公草原因塔公寺而得名。塔公寺是藏传佛教萨迦派寺庙之一，有“小大昭寺”之称，是康巴地区藏民朝拜的圣地之据传说公元641年文成公主进藏与松赞干布完婚时途经木雅人居住的这片草地
                                                                                。前往玛尼河谷后经香薰谷（犹如‘普罗旺斯’一样的薰衣草花海，新增的秘境美景，真是犹如梦境）。返回“光与影的世界”摄影天堂—新都桥镇入住。
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div class="tourline_v4 multiple_item wan_type undefined">
                                                        <div class="multiple_item_inner">
                                                            <div class="hline">

                                                            </div>
                                                            <h4>
                                                                <i class="customTravel"></i>
                                                                活动：
                                                                <span class="item_title">
                                                                    全球户外
                                                                </span>
                                                            </h4>

                                                            <div class="multiple_item_con">
                                                                <div>
                                                                    <div class="item_detail">
                                                                        <div class="item_pic">
                                                                            <img src="https://dimg04.c-ctrip.com/images/03C6n120004h076sd95A2_C_300_300.jpg"
                                                                                 alt="">
                                                                        </div>
                                                                        <div class="desc">
                                                                            <p class="j_description">
                                                                                早上07:00成都统一集合出发（3环内专车上门接），经成雅高速进入甘孜藏族自治州境内，翻越康巴第一关折多山，后前往中国的百慕大—八美墨石公园景区游玩，步入墨石公园，传说当年格萨尔王王妃珠姆在此游玩之时，不小心掉下一条丝巾，
                                                                                落在这片格萨尔王战斗过的土地上，变成了卡玛河，滋润着这片石林及当地的人们。石林含钙盐，受空气湿度的影响，
                                                                                干燥季节呈浅灰色、浅蓝色，湿润季节呈苍黑色，又称之为变色石林。午餐后前往塔公草原，藏语意为“菩萨喜欢的地方”，塔公草原因塔公寺而得名。塔公寺是藏传佛教萨迦派寺庙之一，有“小大昭寺”之称，是康巴地区藏民朝拜的圣地之据传说公元641年文成公主进藏与松赞干布完婚时途经木雅人居住的这片草地
                                                                                。前往玛尼河谷后经香薰谷（犹如‘普罗旺斯’一样的薰衣草花海，新增的秘境美景，真是犹如梦境）。返回“光与影的世界”摄影天堂—新都桥镇入住。
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div class="tourline_v4 multiple_item wan_type undefined">
                                                        <div class="multiple_item_inner">
                                                            <div class="hline">

                                                            </div>
                                                            <h4>
                                                                <i class="customTravel"></i>
                                                                活动：
                                                                <span class="item_title">
                                                                    全球户外
                                                                </span>
                                                            </h4>

                                                            <div class="multiple_item_con">
                                                                <div>
                                                                    <div class="item_detail">
                                                                        <div class="item_pic">
                                                                            <img src="https://dimg04.c-ctrip.com/images/03C6n120004h076sd95A2_C_300_300.jpg"
                                                                                 alt="">
                                                                        </div>
                                                                        <div class="desc">
                                                                            <p class="j_description">
                                                                                早上07:00成都统一集合出发（3环内专车上门接），经成雅高速进入甘孜藏族自治州境内，翻越康巴第一关折多山，后前往中国的百慕大—八美墨石公园景区游玩，步入墨石公园，传说当年格萨尔王王妃珠姆在此游玩之时，不小心掉下一条丝巾，
                                                                                落在这片格萨尔王战斗过的土地上，变成了卡玛河，滋润着这片石林及当地的人们。石林含钙盐，受空气湿度的影响，
                                                                                干燥季节呈浅灰色、浅蓝色，湿润季节呈苍黑色，又称之为变色石林。午餐后前往塔公草原，藏语意为“菩萨喜欢的地方”，塔公草原因塔公寺而得名。塔公寺是藏传佛教萨迦派寺庙之一，有“小大昭寺”之称，是康巴地区藏民朝拜的圣地之据传说公元641年文成公主进藏与松赞干布完婚时途经木雅人居住的这片草地
                                                                                。前往玛尼河谷后经香薰谷（犹如‘普罗旺斯’一样的薰衣草花海，新增的秘境美景，真是犹如梦境）。返回“光与影的世界”摄影天堂—新都桥镇入住。
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>-->


                                    </div>
                                </div>
                            </div>
                        </div>


                        <div id="3" class="j_jouneyContract contract_detail">
                            <h3 class="detail_title">
                                参考报价
                                <i class="detail_icon icon_d">

                                </i>
                            </h3>

                            <div class="contract_text">
                                <div class="reference_mod js_price_container">
                                    <h4 class="title">
                                        人均价格
                                    </h4>
                                    <div class="price_cont">
                                        <dfn>¥</dfn>
                                        <span class="price">
                                            {{ per_price }}
                                        </span>
                                        /人
                                    </div>
                                    <p class="tips">
                                        该价格为案例参考报价，最终价格以实际合同为准
                                    </p>
                                </div>

                                <div class="reference_mod">
                                    <h4 class="title">
                                        价格包含
                                    </h4>
                                    <div class="js_price_resource" style="margin-bottom: 10px;">
                                        <!--<p class="j_description" style="margin: 0px; line-height: initial;">
                                            门票：行程所列景点门票
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;">
                                            用餐：全程含餐1早3正【其中安排一顿当地特色牦牛肉汤锅】
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;">
                                            用车：根据出行人数安排7座/12座/17座/19座/30座/39座
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;">
                                            酒店：行程所列酒店住宿费用
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;">
                                            导游：根据出行人数安排专职导游服务
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;">
                                            意险：旅游意外险
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;">

                                        </p>-->

                                        {{ bj_yes }}
                                    </div>

                                    <h4 class="title">
                                        价格不包含
                                    </h4>

                                    <div class="js_price_resource" style="margin-bottom: 10px;">
                                        <!--<p class="j_description" style="margin: 0px; line-height: initial;">
                                            1、机票：出发地往返目的地机票
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;">
                                            2、火车票：出发地往返目的地火车
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;">
                                            3、一切个人消费及上述费用包含中未提及的项目
                                        </p>
                                        <p class="j_description" style="margin: 0px; line-height: initial;"></p>-->
                                        {{ bj_no }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="4" class="contract_detail">
                            <h3 class="detail_title">
                                预订须知
                                <i class="detail_icon icon_f">

                                </i>
                            </h3>
                            <div class="contract_text">
                                <strong>
                                    1) 为您提供旅游平台及相应的技术支持服务，并作为第三方平台给予您必要的协助。本产品由具备资质的
                                    <span class="providerName fixProvider">
                                        ...
                                    </span>
                                    提供方案设计，资源确认，合同签署等全部环节的旅游服务。在合同生效前，您与商家双方均有权更改或取消订单，且无须承担任何损失。
                                </strong>
                                <br>
                                2) 本报价不含报价单所列项目以外的费用，以及报价单中标注为自理或仅供参考的项目。
                                <br>
                                3) 您在付款成功后，如需更改、取消、退订，将按您所订资源的退变更条款收取费用。
                                <br>
                                4) 如您中途要求更改行程(如增加景点、更改行程或者更改游览顺序)，您需要按实际费用变化情况，承担所增加的地接费用。
                                <br>
                                5)
                                如因意外事件及不可抗力，包括但不限于，航空公司运力调配、航权审核、机场临时关闭、天气原因、航空管制等，导致航班取消或延期的，我公司将尽最大努力协助您办理变更事宜，如产生差价，多退少补。
                                <br>
                                6)
                                您在预订时，务必提供准确、完整的信息（包括但不限于姓名、性别、证件号码、国籍、联系方式、是否成人或儿童），以免产生预订错误，影响出行。如因您所提供的错误个人信息而造成损失，我公司不承担任何责任。

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!--底部-->
        <home-footer></home-footer>

        <div class="showMessageBox" v-show="showMessageBox">
            <div class="showMessageBoxIn">
                <div class="showMessageBoxInDiv">
                    <div class="closeImg" @click="closeBox()">
                        <img class="closeImgIcon" src="@/assets/images/travel/round_close.png" alt="">
                    </div>

                    <div class="startCity">
                        <span class="startCityText">
                            出发
                        </span>
                        <!--<input type="text" class="startCityInput" placeholder="请选择出发城市" v-model="firstCity"
                               disabled="disabled">-->
                        <el-cascader
                                class="startCityInput"
                                size="small"
                                :options="options"
                                v-model="firstCity"
                                @change="handleChange"
                                :value="addressInfo"
                        >
                        </el-cascader>
                        <img class="iconRight" src="@/assets/images/travel/icon_right.png" alt="">
                        <span class="startCityText">
                            目的地
                        </span>
                        <div class="endCity">
                            <!--<input type="text" class="startCityInput" v-model="endCity" disabled="disabled">-->
                            <el-cascader
                                    class="startCityInput"
                                    size="small"
                                    :options="options"
                                    v-model="endCity"
                                    @change="handleChangeEnd"
                                    :value="addressInfoEnd"
                            >
                            </el-cascader>
                        </div>
                    </div>
                    <div class="startCity">
                        <!--<input type="text" class="startTime" placeholder="出发时间" v-model="timeStart" disabled="disabled">-->
                        <span class="startCityText">
                            时间
                        </span>
                        <el-date-picker
                                class="startTime"
                                v-model="timeStart"
                                type="date"
                                placeholder=""
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="startCity">
                        <input type="text" class="telPhone" placeholder="手机号" v-model="formTelephone" maxlength="11"
                               onkeyup="value=value.replace(/[^\d\-\d]/g,'')">
                    </div>

                    <div class="submitBtn" @click="submitBtn()">
                        提交
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';

    export default {
        name: "travelDetail",
        components: {
            homeNav,
            homeFooter
        },
        created() {
            var that = this;
            var pm = that.$route.params.cidgid.slice(0,-5);
            var str = pm.split("_");
            //console.log(str[1]);
            //console.log(pm);
            // that.article_id = str[0];
            that.a_id = str[1];
        },
        mounted(){
            this.getCityData();
            this.getTravelDetail();
        },
        data() {
            return {
                a_id: '',
                carouselList: [
                    /*{
                        banner_img: require('@/assets/images/index/home_img_banner.png'),
                    },
                    {
                        banner_img: require('@/assets/images/index/home_img_banner.png'),
                    },
                    {
                        banner_img: require('@/assets/images/index/home_img_banner.png'),
                    }*/
                ],
                title: '',
                per_price: '',
                destination: '',
                hotel_type: '',
                days: [],
                characteristic: [],
                bj_yes: '',
                bj_no: '',

                travel_days: '',
                showMessageBox: false,
                firstCity: '厦门',
                endCity: '',
                timeStart: new Date(),
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    }
                },
                formTelephone: '',

                addressInfo: '',
                options: [],
                addressInfoEnd: '',
                optionsEnd: [],
                personNum: ''
            }
        },
        methods: {
            toDingzhi(){
                this.$router.push({name:"Travel"});
            },
            getCityData() {
                var that = this;
                that.$axios.get('/provinceAndCity', {}).then((res) => {
                    res = res.data;
                    // console.log(res.data)
                    if (res.status == 200) {
                        that.options = res.data;
                        that.optionsEnd = res.data;
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            getTravelDetail(){
                var travelId = this.a_id ? this.a_id : '';
                this.$axios.post('http://vvv.baostart.com/api/travelDetail', {
                    a_id: travelId
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // console.log(res.data);
                        this.carouselList = res.data.rotation;
                        this.travel_days = res.data.travel_days;
                        this.title = res.data.title;
                        this.per_price = res.data.per_price.split('.')[0];
                        this.destination = res.data.destination;
                        this.hotel_type = res.data.hotel_type;
                        this.days = res.data.days;
                        this.characteristic = res.data.characteristic;
                        this.bj_yes = res.data.bj_yes;
                        this.bj_no = res.data.bj_no;
                    }
                }).catch((err) => {
                    console.log(err)
                });
            },
            showMessage() {
                this.showMessageBox = true;
            },
            submitBtn() {
                var startCity = this.startCity;
                var endCity = this.endCity;
                var timeStart = this.timeStart;
                var personNum = this.personNum;
                var formTelephone = this.formTelephone;

                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

                if (startCity == '' || startCity == undefined || startCity.length <= 0) {
                    this.$message('请选择出发城市');
                    return;
                }

                if (endCity == '' || endCity == undefined || endCity.length <= 0) {
                    this.$message('请选择目的城市');
                    return;
                }

                if (timeStart == '' || timeStart == undefined || timeStart.length <= 0) {
                    this.$message('请选择出发时间');
                    return;
                }

                /*if (personNum == '' || personNum == undefined || personNum.length <= 0) {
                    this.$message('请输入乘车人数');
                    return;
                }*/

                if (!myreg.test(formTelephone)) {
                    this.$message('请输入正确的手机号码');
                    return;
                }

                this.$axios.post('http://vvv.baostart.com/api/trivel_message', {
                    source: 'pc端留言',
                    mobile: formTelephone,
                    start_city: startCity,
                    end_city: endCity,
                    url: '',
                    username: '',
                    start_date: timeStart,
                    people_num: personNum,
                    message_type: ''
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        console.log(res.data);
                        this.$message('提交成功！请耐心等待回电');
                        this.endCity = '';
                        this.formTelephone = '';
                    }
                }).catch((err) => {
                    console.log(err)
                });
            },
            closeBox() {
                this.showMessageBox = false;
            },

            handleChange(value) {
                var that = this;
                var cityName;
                var cityId;
                var provinceName;

                /*if (value[0] == '110000' || value[0] == '120000' || value[0] == '310000' || value[0] == '500000') {
                    cityName = CodeToText[value[0]];
                } else {
                    cityName = CodeToText[value[1]];
                    provinceName = CodeToText[value[0]];
                }*/
                provinceName = value[0];
                cityName = value[1];
                this.startCity = cityName;
            },

            handleChangeEnd(value) {
                var that = this;
                var cityName;
                var cityId;
                var provinceName;

                /*if (value[0] == '110000' || value[0] == '120000' || value[0] == '310000' || value[0] == '500000') {
                    cityName = CodeToText[value[0]];
                } else {
                    cityName = CodeToText[value[1]];
                    provinceName = CodeToText[value[0]];
                }*/
                provinceName = value[0];
                cityName = value[1];
                this.endCity = cityName;
            },
        }
    }
</script>

<style scoped>
    @import './travelDetail.css';
</style>



// WEBPACK FOOTER //
// src/pages/travelDetail/travelDetail.vue